import {FileServiceModerator} from "../moderator/services/file-service-moderator.service";
import {NgModule} from "@angular/core";

@NgModule({
  imports: [
  ],
  declarations: [
  ],
  providers: [
    FileServiceModerator
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class EnrollModeratorSharedModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/enroll-moderator-shared.module.ts